<div id="loader" *ngIf="loader"><span class="spinner-border spinner-grow-lg"></span></div>

<form (submit)="submit()">
	<div class="form-floating mb-3">
		<textarea
			class="form-control"
			id="content"
			name="task.content"
			[(ngModel)]="task.content"
			[ngClass]="{ error: this.errors.content }"
			style="height: 100px"
		></textarea>
		<label for="content">Treść</label>
	</div>
	<div class="form-floating mb-3">
		<input
			type="datetime-local"
			class="form-control"
			id="deadline"
			name="deadline_date"
			[(ngModel)]="task.deadline"
			[ngClass]="{ error: this.errors.deadline }"
		/>
		<label for="deadline">Termin</label>
	</div>
	<div class="form-floating mb-3">
		<select
			class="form-select"
			id="type"
			name="type"
			[(ngModel)]="task.type"
			[ngClass]="{ error: this.errors.type }"
		>
			<option *ngFor="let item of types" value="{{ item.id }}">{{ item.name }}</option>
		</select>
		<label for="type">Typ</label>
	</div>
	<div class="mb-3">
		<label class="form-label" for="user">Przypisane do:</label>
		<ng-select
			id="user"
			name="user"
			[(ngModel)]="task.owners"
			[items]="users"
			placeholder="(wybierz)"
			bindLabel="name"
			bindValue="id"
			[multiple]="true"
			[ngClass]="{ error: this.errors.owners }"
		>
		</ng-select>
	</div>
	<div class="row text-center">
		<button type="submit" class="btn btn-primary" *ngIf="!this.loader">Dodaj</button>
	</div>
</form>
